import * as React from 'react';

import { theme } from '../../styled';
import { IconProps } from './Icon';

export const TimeWaitingIcon = ({ width, height, color }: IconProps) => {
  const DEFAULT_COLOR = theme.colors.text.lightOrange;

  /* eslint-disable-next-line react/style-prop-object */
  return (
    <svg
      fill={color || DEFAULT_COLOR}
      height={height}
      viewBox="0 0 10 10"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3259_18262)">
        <mask
          height="10"
          id="mask0_3259_18262"
          maskUnits="userSpaceOnUse"
          width="10"
          x="0"
          y="0"
        >
          <path d="M0 0H10V10H0V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_3259_18262)">
          <path
            clipRule="evenodd"
            d="M4.22681 1.14897C5.13142 0.966914 6.10214 1.10079 6.964 1.59839C8.84266 2.68303 9.4863 5.08525 8.40166 6.9639C7.31702 8.84257 4.91482 9.48621 3.03617 8.40157C1.17014 7.32421 0.522552 4.94692 1.57688 3.07398L2.24035 3.47206C2.42615 3.58354 2.66081 3.57213 2.8349 3.44313C3.00899 3.31414 3.08824 3.09297 3.03569 2.88276L2.63966 1.29863C2.5679 1.01159 2.27704 0.837079 1.99001 0.908836L0.405874 1.30487C0.195667 1.35742 0.0378153 1.53143 0.005924 1.74574C-0.0259672 1.96006 0.074383 2.17249 0.260181 2.28396L0.657859 2.52257C-0.704814 4.91036 0.116753 7.95321 2.50046 9.3295C4.89157 10.71 7.94909 9.89071 9.32959 7.49964C10.7101 5.10851 9.8908 2.05101 7.49973 0.670501C6.40348 0.0375909 5.16584 -0.132924 4.01542 0.0986016C3.72537 0.156976 3.53756 0.43943 3.59593 0.729486C3.65431 1.01954 3.93676 1.20735 4.22681 1.14897ZM5.00009 1.96427C5.29595 1.96427 5.5358 2.20412 5.5358 2.49999V5.05381L7.06142 5.96919C7.31516 6.12141 7.39737 6.45048 7.24516 6.70418C7.09295 6.95789 6.76388 7.04015 6.51018 6.88793L4.72447 5.8165C4.5631 5.71969 4.46437 5.54531 4.46437 5.35713V2.49999C4.46437 2.20412 4.70422 1.96427 5.00009 1.96427Z"
            fill={color}
            fillRule="evenodd"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3259_18262">
          <rect fill="white" height="10" width="10" />
        </clipPath>
      </defs>
    </svg>
  );
};
